export class ApiError extends Error {
  status: number;
  /** Machine-readable error code from the body, e.g. `handle_taken` or Better Auth's `INVALID_OTP`. */
  code: string | undefined;
  body: unknown;

  constructor(status: number, message: string, code?: string, body?: unknown) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.code = code;
    this.body = body;
  }
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const response = await fetch(path, {
    method,
    headers: body !== undefined ? { "Content-Type": "application/json" } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  let data: unknown;
  try {
    data = await response.json();
  } catch {
    data = { message: response.statusText };
  }

  if (!response.ok) {
    const record = typeof data === "object" && data !== null ? (data as { message?: unknown; code?: unknown }) : {};
    const message = record.message !== undefined ? String(record.message) : response.statusText;
    const code = typeof record.code === "string" ? record.code : undefined;
    throw new ApiError(response.status, message, code, data);
  }

  return data as T;
}

export const apiGet = <T>(path: string): Promise<T> => request<T>("GET", path);
export const apiPost = <T>(path: string, body?: unknown): Promise<T> => request<T>("POST", path, body);
export const apiPut = <T>(path: string, body?: unknown): Promise<T> => request<T>("PUT", path, body);
export const apiPatch = <T>(path: string, body?: unknown): Promise<T> => request<T>("PATCH", path, body);
export const apiDelete = <T>(path: string): Promise<T> => request<T>("DELETE", path);
